﻿import { removeLeadingForwardSlash } from "@/helpers";
import { BaseQueryFn, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Modal } from "antd";
import { authorizationHeaders } from "./authorizationHeaders";
import { getModalApi } from "./antdApp";

let authErrorDialogShown = false;

const showAuthErrorDialog = async (status: number): Promise<void> => {
  if (authErrorDialogShown) {
    return;
  }

  authErrorDialogShown = true;

  const isUnauthorized = status === 401;

  await new Promise<void>((resolve) => {
    const modalApi = getModalApi();
    const showError = modalApi?.error ?? Modal.error;

    showError({
      title: isUnauthorized ? "Unauthorized" : "Access Denied",
      content: isUnauthorized
        ? "Your session has expired or you are not authorized. You will be redirected to the home page."
        : "You do not have permission to access this resource. You will be redirected to the home page.",
      onOk: () => {
        window.location.href = "/";
        resolve();
      },
    });
  });
};

export const fetchBaseQueryWrapper = ({
  path = "",
  baseUrl = undefined,
  extraOptions = {},
} = {}): BaseQueryFn => {
  const baseQuery = fetchBaseQuery({
    baseUrl:
      typeof baseUrl === "string"
        ? baseUrl
        : `api/v1${path && `/${removeLeadingForwardSlash(path)}`}`,
    prepareHeaders: (headers) => authorizationHeaders(headers),
    ...extraOptions,
  });

  const baseQueryWithAuthHandling: BaseQueryFn = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (
      result.error &&
      typeof result.error === "object" &&
      "status" in result.error &&
      (result.error.status === 401 || result.error.status === 403)
    ) {
      await showAuthErrorDialog(result.error.status as number);
    }

    return result;
  };

  return baseQueryWithAuthHandling;
};
